import React from 'react';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  title: 'Functional Session Scriptbook™',
  description: 'The exact words elite coaches use. Ready-to-use cues, corrections, and communication scripts for every movement pattern and every coaching situation.'
}, {
  title: '12-Week Functional Challenge Calendar™',
  description: 'A done-for-you 12-week client challenge system with weekly structures, habit trackers, and engagement tools. Launch it with your next client immediately.'
}, {
  title: 'Functional Assessment Quickstart Kit™',
  description: 'Simple movement screening tools, intake forms, and goal-setting worksheets that bridge directly from assessment to professional session planning.'
}, {
  title: 'Functional Equipment Circuit Playbook™',
  description: 'Ready-to-use circuit systems for dumbbells, kettlebells, bands, TRX, med balls, and bodyweight. 25 complete templates to keep every session fresh and professional.'
}, {
  title: 'Client Progress Dashboard Pack™',
  description: 'Simple tracking dashboards and milestone review tools that make client results visible — and keep them committed, motivated, and coming back.'
}];
const included = ['The Complete FUNCTIONAL PRO™ 6-in-1 System', 'All 6 Professional Modules', 'Over 500 Pages of Content', 'All 5 Exclusive Bonuses', 'Instant Digital Access'];
export function BonusSection() {
  return <>
      <section className="py-8 sm:py-10 px-4 bg-white border-y border-brand-gold/30" data-id="element-15" data-mp="1vs201uojy9tl">
        <div className="max-w-4xl mx-auto" data-id="element-16" data-mp="20remiebihevn">
          <div className="text-center mb-5" data-id="element-17" data-mp="20qdekipsl8i5">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-2" data-id="element-18" data-mp="20trdti35t1ld">
              5 PROFESSIONAL BONUSES INCLUDED
            </h2>
            <p className="text-lg text-brand-graphite/70 mb-2" data-id="element-19" data-mp="3c5s7nbevrg7z">
              Plus, you'll receive 5 exclusive professional bonuses
            </p>
            <p className="text-base text-brand-graphite/80" data-id="element-20" data-mp="1h3eyxf99cr0w">
              Powerful resources that will transform your day-to-day coaching —
              included FREE with your system.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6" data-id="element-21" data-mp="1q4lixyb48jyw">
            {bonuses.map((bonus, i) => <div key={i} className="bg-brand-cream border-2 border-brand-gold/40 p-5 rounded-lg text-center" data-id="element-22" data-mp="1m3jkvksxqdyi" data-mpi={i}>
                <div className="w-12 h-12 mx-auto bg-brand-gold/20 rounded-full flex items-center justify-center mb-3" data-id="element-23" data-mp="tdt4t67qt1zr">
                  <Gift className="w-6 h-6 text-brand-petrol" data-id="element-24" data-mp="175r7ay6y7zmy" />
                </div>
                <p className="text-xs font-bold text-brand-gold mb-2" data-id="element-25" data-mp="12er9lqq09dje">
                  BONUS {i + 1} 🎁 FREE
                </p>
                <h3 className="text-base font-bold text-brand-graphite mb-2" data-id="element-26" data-mp="envae8j7zg24">
                  {bonus.title}
                </h3>
                <p className="text-sm text-brand-graphite/70 leading-relaxed" data-id="element-27" data-mp="an315faclb5u">
                  {bonus.description}
                </p>
              </div>)}
          </div>

          <p className="text-center font-bold text-brand-petrol text-lg" data-id="element-28" data-mp="5bo1cx8t9zn7">
            ALL 5 BONUSES ARE FREE WITH YOUR PURCHASE TODAY
          </p>
        </div>
      </section>

      <section className="py-8 sm:py-10 px-4 bg-brand-cream" data-id="element-29" data-mp="3rqr0sjiqgjbx">
        <div className="max-w-3xl mx-auto" data-id="element-30" data-mp="j9w4xo0crz7c">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center text-brand-graphite mb-2" data-id="element-31" data-mp="jb7bfvl6nl25">
            WHAT IS GOING TO CHANGE
          </h2>
          <p className="text-base text-center text-brand-graphite/70 mb-1" data-id="element-32" data-mp="9byk7ahpckjh">
            What will change in your professional life
          </p>
          <p className="text-base text-center text-brand-graphite/80 mb-5 font-semibold" data-id="element-33" data-mp="e9huy0f6yf6o">
            Real results starting from your very first week:
          </p>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-34" data-mp="2z1jqkn9x25au">
            {[{
            emoji: '⚡',
            title: 'Zero Programming Stress',
            desc: "Open the system, select the session that matches your client's goal and level, and coach. The programming is already done — professionally structured and ready to use."
          }, {
            emoji: '👑',
            title: 'Instant Authority and Confidence',
            desc: "Walk into every session knowing exactly what you're doing, why you're doing it, and what to say. Your clients feel the difference from day one."
          }, {
            emoji: '🌿',
            title: 'Real Client Progression',
            desc: 'Biomechanically sound programming with built-in progressions so your clients actually improve — and keep coming back because they can feel the results.'
          }, {
            emoji: '😌',
            title: 'More Time. Less Burnout.',
            desc: 'Stop spending your weekends building sessions. Reclaim your time, protect your energy, and focus on what you became a coach to do — transform lives.'
          }].map((item, i) => <div key={i} className="bg-white border-2 border-brand-petrol/20 p-5 rounded-lg" data-id="element-35" data-mp="s9axa0wso00t" data-mpi={i}>
                <div className="text-3xl mb-2" data-id="element-36" data-mp="122i6xxyki26p">{item.emoji}</div>
                <h3 className="text-lg font-bold text-brand-petrol mb-2" data-id="element-37" data-mp="170ticd4igkr1">
                  {item.title}
                </h3>
                <p className="text-brand-graphite/80 text-sm leading-relaxed" data-id="element-38" data-mp="1b1debddclibl">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}